import React from 'react';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import { FileExplorerModalProps } from '../../../types/fileExplorerTypes';

import { ControlledModal } from '../../common/ControlledModal';
import { renameFile, TreeFile } from '../services';
import { RenameFileForm } from '../Forms/RenameFileForm';
import { renameFileSchema, RenameFileSchema } from '../Forms/schemas';
import { useFileExplorerMutation } from '../../../hooks/useFileExplorerMutation';

const GENERIC_ERROR_MESSAGE = 'Error al renombrar el archivo';

export function RenameFileModal({ show, onHide, data }: FileExplorerModalProps<TreeFile>) {
  if (!data || !show) return null;
  const mutationFn = (values: RenameFileSchema) => renameFile(data.id, values);
  const form = useForm<RenameFileSchema>({
    resolver: zodResolver(renameFileSchema),
    values: {
      title: data.title,
    },
  });

  const handleSuccess = () => {
    form.reset();
    onHide?.();
  };

  const {
    mutateAsync, isLoading, reset,
  } = useFileExplorerMutation<RenameFileSchema>({
    mutationFn,
    onSuccess: handleSuccess,
  });

  const handleRename = (values: RenameFileSchema) => {
    const renamePromise = mutateAsync(values);
    toast.promise(renamePromise, {
      loading: 'Renombrando archivo...',
      success: 'Archivo renombrado exitosamente',
      error: {
        message: 'Error al renombrar archivo',
        description: GENERIC_ERROR_MESSAGE,
      },
    });
  };

  const handleClose = () => {
    form.reset();
    reset();
    onHide?.();
  };
  return (
    <ControlledModal
      show={show}
      onHide={handleClose}
      title="Renombrar archivo"
      closeButton
      centered
    >
      <Modal.Body>
        <RenameFileForm form={form} onSubmit={handleRename}>
          <ControlledModal.Actions handleClose={handleClose} isPending={isLoading} cancelButton />
        </RenameFileForm>
      </Modal.Body>
    </ControlledModal>
  );
}
